import { TransactionType } from "../../proto/generated/order"
import { OptionType, SecurityCategory_CategoryCode } from "../../proto/generated/security"
import { StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType, StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType, StrategyTemplateProto_StrategyTemplateGroup } from "../../proto/generated/strategy"

export enum StrategyGroup {
    BULLISH = 'Bullish',
    BEARISH = 'Bearish',
    NEUTRAL = 'Neutral',
    CUSTOM = 'Saved'
}

export const strategyCriteriaList = (showPrevLegOption = false) => [
    {
        key: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_POINT,
        label: 'ATM Point'
    },
    {
        key: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_PERCENTAGE,
        label: 'ATM Percent'
    },
    {
        key: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STRADDLE_WIDTH,
        label: 'Straddle Width'
    },
    {
        key: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_PREMIUM,
        label: 'Closest Premium (CP)'
    },
    {
        key: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CP_ON_STRADDLE_PREMIUM,
        label: 'CP based on Straddle Premium (SP)'
    },
    {
        key: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STANDARD_DEVIATION,
        label: 'Standard Deviation'
    },
    {
        key: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA,
        label: 'Closest Delta'
    },
    ...(showPrevLegOption ? [{
        key: StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.SAME_AS_PREVIOUS_LEG,
        label: 'Same as Previous Leg'
    }] : [])
]

export const strategyCriteriaToStrikeParams = {
    atmPoint: {
        atmDependent: true,
        numberOfPoints: 20,
        negativePoints: true,
        difference: 'strikeDifference',
        multiplier: undefined
    },
    atmPercent: {
        atmDependent: true,
        numberOfPoints: 40,
        negativePoints: true,
        difference: 0.25,
        multiplier: undefined
    },
    straddlWidth: {
        atmDependent: true,
        numberOfPoints: 40,
        negativePoints: true,
        difference: 0.25,
        multiplier: 'SP'
    },
    cp: {
        atmDependent: true,
        numberOfPoints: 40,
        negativePoints: true,
        difference: 0.25,
        multiplier: 'CP'
    }
}

export const instrumentTypes = [
    {
        key: SecurityCategory_CategoryCode.FUTURES,
        label: 'FUT'
    },
    {
        key: SecurityCategory_CategoryCode.OPTIONS,
        label: 'OPT'
    }
]

export const optionTypes = [
    {
        key: OptionType.CE,
        label: 'CE'
    },
    {
        key: OptionType.PE,
        label: 'PE'
    }
]

export const actionTypes = [
    {
        key: TransactionType.BUY,
        label: 'Buy'
    },
    {
        key: TransactionType.SELL,
        label: 'Sell'
    }
]

export const expiryTypes = (isFuture=false) =>([
    ...(isFuture ? [] : [
        {
            key: StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.WEEKLY,
            label: 'Weekly'
        },
        {
            key: StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.NEXT_WEEKLY,
            label: 'Next Weekly'
        },
        {
            key: StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MINIMUM_DAYS_TO_MONTHLY_EXPIRY,
            label: 'Min. Days to Expiry'
        }
    ]),
    {
        key: StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MONTHLY,
        label: 'Monthly'
    },
    {
        key: StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.NEXT_MONTHLY,
        label: 'Next Monthly'
    }
])

export const getExpiryTypeLabel = (type: StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType, isFuture=false) => {
    const types = expiryTypes(isFuture)
    return types.find(t=>t.key===type)?.label
}

export enum EqualityOperator {
    '~' = 1,
    '>=' = 2,
    '<=' = 3
}

export const EqualityOperatortoJson = (value: EqualityOperator) => {
    switch(value) {
        case EqualityOperator['~']:
            return '~'
        case EqualityOperator['>=']:
            return '>='
        case EqualityOperator['<=']:
            return '<='
        default:
            return ''
    }
}

export const CategoryGroupNameToCode: Record<string, StrategyGroup> = {
    [`${StrategyTemplateProto_StrategyTemplateGroup.BULLISH}`]: StrategyGroup.BULLISH,
    [`${StrategyTemplateProto_StrategyTemplateGroup.BEARISH}`]: StrategyGroup.BEARISH,
    [`${StrategyTemplateProto_StrategyTemplateGroup.NEUTRAL}`]: StrategyGroup.NEUTRAL,
    [`${StrategyTemplateProto_StrategyTemplateGroup.CUSTOM}`]: StrategyGroup.CUSTOM
}